// # Payment Product Component
import React from 'react';
import { 
  FaMoneyBill, 
  FaClock,
  FaChalkboardTeacher
} from 'react-icons/fa';
// # Import component-specific styles
import './pay_product.css';

// # PayProduct component for handling product selection and related fields
const PayProduct = ({ 
  formData, 
  handleChange, 
  productTypes, 
  teamMembers, 
  tutors 
}) => {
  return (
    <div className="fnc_pay_reg_section">
      <div className="fnc_pay_reg_section-header">
        <FaMoneyBill />
        <h2>Payment Details</h2>
      </div>
      
      <div className="fnc_pay_reg_form-group">
        <label>
          <FaMoneyBill className="fnc_pay_reg_input-icon" />
          Product Type
        </label>
        <select 
          name="product" 
          value={formData.product}
          onChange={handleChange}
          required
          className="fnc_pay_reg_product-select"
        >
          <option value="">Select Product Type</option>
          
          {/* Library Products */}
          <optgroup label="Library Access" className="fnc_pay_reg_product-group">
            <option value="step1_library" className="fnc_pay_reg_product-option fnc_pay_reg_product-library">
              Step 1 Library Access
            </option>
            <option value="step2_library" className="fnc_pay_reg_product-option fnc_pay_reg_product-library">
              Step 2 Library Access
            </option>
          </optgroup>

          {/* Premium Products */}
          <optgroup label="Premium Access" className="fnc_pay_reg_product-group">
            <option value="step1_premium" className="fnc_pay_reg_product-option fnc_pay_reg_product-premium">
              Step 1 Premium
            </option>
            <option value="step2_premium" className="fnc_pay_reg_product-option fnc_pay_reg_product-premium">
              Step 2 Premium
            </option>
          </optgroup>

          {/* Mentorship Products */}
          <optgroup label="Mentorship" className="fnc_pay_reg_product-group">
            <option value="step1_mentorship" className="fnc_pay_reg_product-option fnc_pay_reg_product-mentorship">
              Step 1 Mentorship
            </option>
            <option value="step2_mentorship" className="fnc_pay_reg_product-option fnc_pay_reg_product-mentorship">
              Step 2 Mentorship
            </option>
          </optgroup>

          {/* Tutor Hosting Products */}
          <optgroup label="Tutor Hosting" className="fnc_pay_reg_product-group">
            <option value="step1_tutor_hosting" className="fnc_pay_reg_product-option fnc_pay_reg_product-tutor">
              Step 1 Tutor Hosting
            </option>
            <option value="step2_tutor_hosting" className="fnc_pay_reg_product-option fnc_pay_reg_product-tutor">
              Step 2 Tutor Hosting
            </option>
          </optgroup>

          {/* Other Products */}
          <optgroup label="Other Products" className="fnc_pay_reg_product-group">
            <option value="OET" className="fnc_pay_reg_product-option fnc_pay_reg_product-other">
              OET
            </option>
            <option value="US_VISA_Counselling" className="fnc_pay_reg_product-option fnc_pay_reg_product-other">
              US VISA Counselling
            </option>
          </optgroup>
        </select>
      </div>

      {formData.product?.includes('library') && (
        <div className="fnc_pay_reg_form-group">
          <label>
            <FaClock className="fnc_pay_reg_input-icon" />
            Duration
          </label>
          <select 
            name="duration" 
            value={formData.duration}
            onChange={handleChange}
            required
          >
            <option value="">Select Duration</option>
            {productTypes[formData.product].durations.map(duration => (
              <option key={duration} value={duration}>{duration}</option>
            ))}
          </select>
        </div>
      )}

      {formData.product?.includes('mentorship') && (
        <>
          <div className="fnc_pay_reg_form-group">
            <label>
              <FaClock className="fnc_pay_reg_input-icon" />
              Duration
            </label>
            <input 
              type="text"
              name="duration"
              value="1 month"
              disabled
              className="fnc_pay_reg_input-disabled"
            />
          </div>
          <div className="fnc_pay_reg_form-group">
            <label>
              <FaChalkboardTeacher className="fnc_pay_reg_input-icon" />
              Assigned Mentor
            </label>
            <select 
              name="mentor" 
              value={formData.mentor}
              onChange={handleChange}
              required
            >
              <option value="">Select Mentor</option>
              {teamMembers.map((mentor) => (
                <option key={mentor.id} value={mentor.id}>{mentor.name}</option>
              ))}
            </select>
          </div>
        </>
      )}

      {(formData.product === 'OET' || formData.product === 'US_VISA_Counselling') && (
        <>
          <div className="fnc_pay_reg_form-group">
            <label>
              <FaClock className="fnc_pay_reg_input-icon" />
              Duration
            </label>
            <input 
              type="text"
              name="duration"
              value="1 month"
              disabled
              className="fnc_pay_reg_input-disabled"
            />
          </div>
          <div className="fnc_pay_reg_form-group">
            <label>
              <FaChalkboardTeacher className="fnc_pay_reg_input-icon" />
              Assigned Mentor
            </label>
            <select 
              name="mentor" 
              value={formData.mentor}
              onChange={handleChange}
              required
            >
              <option value="">Select Mentor</option>
              {teamMembers.map((mentor) => (
                <option key={mentor.id} value={mentor.id}>{mentor.name}</option>
              ))}
            </select>
          </div>
        </>
      )}

      {formData.product?.includes('tutor_hosting') && (
        <>
          <div className="fnc_pay_reg_form-group">
            <label>
              <FaClock className="fnc_pay_reg_input-icon" />
              Duration
            </label>
            <input 
              type="text"
              name="duration"
              value="1 month"
              disabled
              className="fnc_pay_reg_input-disabled"
            />
          </div>
          <div className="fnc_pay_reg_form-group">
            <label>
              <FaChalkboardTeacher className="fnc_pay_reg_input-icon" />
              Assigned Tutor
            </label>
            <select 
              name="tutor" 
              value={formData.tutor?.id}
              onChange={handleChange}
              required
            >
              <option value="">Select Tutor</option>
              {tutors.map((tutor) => (
                <option key={tutor.id} value={tutor.id}>
                  {tutor.name} - {tutor.email}
                </option>
              ))}
            </select>
          </div>
        </>
      )}
    </div>
  );
};

export default PayProduct;
